import { LiveChatSettings } from "types/api"

import { DEFAULT_INHOUSE_HOST, EXAMPLE_WORKSPACE_KEY } from "./constants"
import { CredentialProvider, FormState } from "./types"

interface CredentialField {
  key: keyof FormState
  /** Suffix under `settings.liveChat.credentials.<provider>.` */
  labelKey: string
  hintKey?: string
  /** Literal placeholder; when absent a shared "from environment" / "not set" one is used. */
  placeholder?: string
  secret?: boolean
  /** Which `secretsPresent` flag says whether a value is already stored. */
  storedFlag?: keyof LiveChatSettings["secretsPresent"]
  /** Which `envFallbacks` flag says the API can fall back to an env var. */
  envFlag?: keyof LiveChatSettings["envFallbacks"]
}

export interface ProviderFieldGroup {
  provider: CredentialProvider
  fields: CredentialField[]
}

/** Described once per provider so the sections render from data, not duplicated JSX. */
export const PROVIDER_FIELD_GROUPS: ProviderFieldGroup[] = [
  {
    provider: "intercom",
    fields: [
      { key: "intercomAppId", labelKey: "appId" },
      {
        key: "intercomHashKey",
        labelKey: "hashKey",
        secret: true,
        storedFlag: "intercomHashKey",
        envFlag: "intercomHashKey"
      }
    ]
  },
  {
    provider: "tawk",
    fields: [
      { key: "tawkPropertyId", labelKey: "propertyId", hintKey: "propertyIdHint" },
      { key: "tawkWidgetId", labelKey: "widgetId" },
      { key: "tawkApiKey", labelKey: "apiKey", secret: true, storedFlag: "tawkApiKey", envFlag: "tawkApiKey" }
    ]
  },
  {
    provider: "inhouse",
    fields: [
      { key: "inhouseHost", labelKey: "host", hintKey: "hostHint", placeholder: DEFAULT_INHOUSE_HOST },
      {
        key: "inhousePublicKey",
        labelKey: "publicKey",
        hintKey: "publicKeyHint",
        placeholder: EXAMPLE_WORKSPACE_KEY
      },
      { key: "inhouseHashSecret", labelKey: "hashSecret", secret: true, storedFlag: "inhouseHashSecret" }
    ]
  }
]
